import { Injectable } from "@angular/core";
import { Api } from "../services/api";

@Injectable({
  providedIn: "root"
})
export class SourceService {
  constructor(public api: Api) {}

  // getAllSources() {
  //   let seq = this.api.get('master/v1/getsources');
  //   return seq;
  // }
}
